import { addRule } from 'redux-ruleset'
import config from 'config'

if (typeof window !== 'undefined' && config.features.liveChat) {
  addRule({
    id: 'liveChat/changeRoute',
    target: 'navigation/LOCATION_CHANGED',
    output: '#style-change',
    consequence: (action) => {
      const checkoutRoute = action.payload.pathname.includes('/checkout/')
      const element = document.getElementById(
        'Microsoft_Omnichannel_LCWidget_Chat_Iframe_Window'
      )
      if (checkoutRoute) {
        element?.style.setProperty('display', 'none')
      } else {
        element?.style.setProperty('display', 'block')
      }
    }
  })
}
